
<div>
  <JobPostConfirmTransitionText v-if="showTransitionText" />
  <h2 class="text-h2 my-32">
    {{
      draft.isPrepopulatedFromReservation
        ? 'Let’s help you find a caregiver by sharing your Back-Up Care request'
        : 'Review your job'
    }}
  </h2>
  <form @submit.prevent="submit">
    <Card class="flex flex-col sm:p-24">
      <RouteStepperReview :reviewSections="reviewSections" />
      <p class="text-xs leading-5 text-grey-text-subdued mb-16 border-t-1 border-solid border-grey-divider-subdued pt-24">
        OpenAI used the information you have provided about this job to generate your job description. The generated output may
        contain errors. You agree to review it before publishing and understand you are responsible for the information you
        post.
        <a
          class="underline"
          href="https://support.sittercity.com/hc/en-us/articles/23699389621019-Write-your-job-description-with-OpenAI"
          target="_blank"
        >
          Learn more
        </a>
      </p>
      <Button :loading="isLoading" type="submit" size="medium" class="ml-auto w-full md:max-w-max">Share with sitters</Button>
    </Card>
  </form>
</div>
